(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('DeterminStatusPaymentController', DeterminStatusPaymentController);

    DeterminStatusPaymentController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PaymentLog', 'InvoiceInfo', 'PaymentLogCustom', 'CompanyPaymentLogCustom'];

    function DeterminStatusPaymentController($timeout, $scope, $stateParams, $uibModalInstance, entity, PaymentLog, InvoiceInfo, PaymentLogCustom, CompanyPaymentLogCustom) {
        var vm = this;
        vm.scope = $scope;
        vm.paymentLog = entity.paymentLog;
        vm.clear = clear;
        vm.save = save;
        vm.status = entity.paymentLog.managerApprovalStatus || "NONE";
        vm.statusList = ["CHECKING", "APPROVED", "DENIED"];
        vm.managerApprovalComment = entity.paymentLog.managerApprovalComment;
        vm.price = vm.paymentLog.amount;
        vm.fullName = vm.paymentLog.customer.fisrtName + ' '+ vm.paymentLog.customer.lastName;
        //vm.invoiceinfos =
        vm.closeModal = closeModal;
        vm.okModal = okModal;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if(vm.status !== "NONE") {
                vm.isSaving = true;
                var data = JSON.stringify({
                    managerApprovalStatus: vm.status,
                    comment: vm.managerApprovalComment
                })
                CompanyPaymentLogCustom.updateCompanyPayment(vm.paymentLog.id).update(data).$promise.then(onSaveSuccess, onSaveError)
            }
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function closeModal() {
            clear();

        }

        function okModal() {
            save();
        }

    }
})();
